var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dd707bc6022e302fd109f963eeaf8a6935610f03"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-app@groove"]={id:"dd707bc6022e302fd109f963eeaf8a6935610f03"};
      